/** Parse Base32 secret from standard otpauth://totp/...?secret=... URI */
export function parseTotpSecretFromUri(uri: string): string | null {
  const trimmed = uri.trim();
  if (!trimmed) return null;
  try {
    const secret = new URL(trimmed).searchParams.get("secret")?.trim();
    return secret || null;
  } catch {
    const match = trimmed.match(/[?&]secret=([^&]+)/i);
    if (!match?.[1]) return null;
    try {
      return decodeURIComponent(match[1]).trim() || null;
    } catch {
      return match[1].trim() || null;
    }
  }
}
